<template>
	<div id="menu-w" class="menu-w selected-menu-color-bright menu-activated-on-hover sub-menu-color-dark color-scheme-dark color-style-default sub-menu-color-bright menu-position-top menu-layout-compact sub-menu-style-over"
	:class="(w >= 1200) ? 'sub-menu-style-over' : 'sub-menu-style-inside'">
		<div class="logo-w">
			<router-link :to="{name: 'Dashboard'}" class="logo"><img src="static/assets/img/logo.png"></router-link>
		</div>
		<dock />
	</div>
</template>

<script>
    import Dock from './dock'
    import ProfilePic from '@/components/user/ProfilePic'
    import onlineUsers from '@/components/user/widget/online'
    import VueSticky from 'vue-sticky'

    export default {
        components: { Dock, ProfilePic, onlineUsers },
        directives: {
            'sticky': VueSticky,
        },
        name: 'navigation',
        data () {
            return {
                blurred: true,
	            w: window.innerWidth
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/Navigation.vue